import React from "react";
import TitleFormat from "../../../components/TitleFormat";
import ItCertificationContent from "../../../components/ItCertificationContent";
import { useTranslation } from "react-i18next";
import { Seo } from "../../../components/Seo";

const ItCertification = () => {
  const { t } = useTranslation();
  const title = { text: `${t("it.certification.title")}` };
  return (
    <>
      <Seo title={t("it.certification.seo.title")} description={t("it.certification.seo.des")} path="esg-rnd/global-certification" />
      <TitleFormat text={title.text} />
      <ItCertificationContent />
    </>
  );
};

export default ItCertification;
